<template>
  <div class="copywriting">
    <div class="top-row">
      <p class="tips">
        <i class="el-icon-info"></i>
        <span>只有团队队长才能进行文案的管理操作</span>
      </p>
      <div class="btns">
        <el-button
          type="danger"
          size="medium"
          icon="el-icon-delete"
          :disabled="selectedIds.length == 0 || !isCaptain"
          @click="handleRemove()"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="handleClick"
          :disabled="!isCaptain"
          >新增</el-button
        >
      </div>
    </div>

    <el-table
      :data="list"
      stripe
      @selection-change="handleSelectionChange"
      class="list"
    >
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案名称"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="small"
            type="text"
            @click="
              showDetail = true;
              form = { ...row };
            "
            >查看</el-button
          >
          <template v-if="isCaptain">
            <el-button
              size="small"
              type="text"
              @click="
                form = { ...row };
                waId = row.waId;
                show = true;
              "
              >修改</el-button
            >
            <el-button size="small" type="text" @click="handleRemove(row.waId)"
              >删除</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="waId ? '修改文案' : '新增文案'"
      :visible.sync="show"
      width="55%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="small"
      >
        <el-form-item label="集数" prop="episode">
          <el-input-number v-model="form.episode" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="文案名称" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="文案内容" prop="content">
          <editor
            :outContent="form.content"
            @content="updateContent"
            height="300px"
            placeholder="请输入文案内容"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="detail-dialog"
      :visible.sync="showDetail"
      width="40%"
      center
    >
      <table
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="10"
        align="center"
        class="table"
      >
        <tr>
          <td class="label" width="20%">集数</td>
          <td>第{{ form.episode }}集</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案名称</td>
          <td>{{ form.title }}</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案内容</td>
          <td><div v-html="form.content"></div></td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import {
  myCopywriting,
  info,
  save,
  edit,
  del,
} from "@/api/projectPractice/copywriting";
import editor from "@/components/editor";

export default {
  components: { editor },
  data() {
    return {
      isCaptain: false,
      list: [],
      selectedIds: [],
      waId: null,
      form: {},
      rules: {
        title: { required: true, message: "请输入文案名称", trigger: "blur" },
        episode: { required: true, message: "请输入集数", trigger: "blur" },
        content: { required: true, message: "请输入文案内容", trigger: "blur" },
      },
      show: false,
      showDetail: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {
    show(val) {
      if (!val) this.form = this.$options.data().form;
    },
    showDetail(val) {
      if (!val) this.form = this.$options.data().form;
    },
  },
  methods: {
    getList() {
      this.$loading.show();
      myCopywriting({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.list;
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.itemId);
    },
    handleClick() {
      this.form.episode =
        Math.max(...this.list.map((item) => item.episode)) + 1;
      this.show = true;
    },
    // 删除
    handleRemove(waId) {
      this.$msgbox({
        title: "提示",
        message: "您确定要删除该文案？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            del(waId || this.selectedIds)
              .then(() => {
                this.$message.success("删除成功");
                this.getList();
              })
              .finally(() => {
                done();
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
    updateContent(val) {
      this.form.content = val;
    },
    // 新增/修改
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.classId = this.$route.query.id;
          this.$loading.show();
          (this.waId ? edit : save)(this.form).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getList();
              this.show = false;
              this.$message.success(this.waId ? "修改成功" : "新增成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$confirm("关闭后未保存的编辑内容将丢失,确定要关闭吗?", {
        type: "warning",
      })
        .then(() => {
          this.show = false;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.copywriting {
  .top-row {
    margin-bottom: 10px;
    line-height: 36px;
    overflow: hidden;
    .tips {
      float: left;
      color: #f56c6c;
      i {
        margin-right: 5px;
      }
    }
    .btns {
      float: right;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .detail-dialog {
    .label {
      text-align: center;
      font-weight: bold;
      background: #f5f5f5;
    }
  }
}
</style>